export default "__VITE_ASSET__C1q5WG6D__"